const updateBanners = $(function () {
    window.csp.banner = {
        bannersId: [],

        init: function () {
            const banner = $('.js-updated-banner')[0]
            const bannerPlace = $(banner).attr('data-banner-place')

            if (!banner || !bannerPlace) return

            $.ajax({
                cache: false,
                type: 'GET',
                dataType: 'json',
                url: window.location.origin + '/banner-change/',
                data: {
                    place: bannerPlace,
                    id: window.csp.banner.bannersId
                },
                success: function(response) {
                    const id = response.id
                    if (window.csp.banner.bannerWasUsed(id)) {
                        window.csp.banner.clearBannersId()
                    }
                    $(banner).html(response.banner)
                    window.csp.banner.bannersId.push(id)
                },
                error: function() {
                    window.csp.banner.clearBannersId()
                    window.csp.banner.init()
                }
            });
        },

        bannerWasUsed: function (id) {
            return this.bannersId.indexOf(id) !== -1
        },

        clearBannersId: function () {
            this.bannersId = []
        },

        updateBanner: function () {
            setInterval(this.init, 10000)
        }
    };

    window.csp.banner.init()
    window.csp.banner.updateBanner()
})

window.addEventListener('load', updateBanners)